import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { catchError, Observable, of, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { countries } from '../../assets/data/countries';
// import { ToastService } from './toast-service';
// import { countries } from '../../assets/data/countries';

@Injectable({
  providedIn: 'root'
})
export class Interceptor implements HttpInterceptor {
  token: string | null = null;

  constructor(
    private router: Router  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.token=null;
    request = request.clone({
      setHeaders: {
        'X-API-KEY': environment.apiKey
      }
    });
      if (request.url.endsWith('api/apps/contacts/countries') && request.method === 'GET') {
      return of(new HttpResponse({ status: 200, body: countries }));
    }

    if(typeof window === 'undefined')  return next.handle(request);


    console.log("REQUEST URL ===> ", request.url,request.url.endsWith('/auth/mobile-signup'));  
    if(request.url.endsWith('/auth/mobile-signup')){
        this.token = localStorage.getItem('verifyOtpToken');
    }
    
    if(!this.token) this.token = localStorage.getItem('clientToken');

    console.log("intercept")

    if (this.token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.token}`
        }
      });
    }
   
    return next.handle(request).pipe(
      catchError(err => this.handleAuthError(err))
    );
  }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    // Gérer le cas du token expiré (code 509)
    if (err.status === 509) {
      console.log('Token expiré - Nettoyage du localStorage');
      localStorage.clear();
      this.router.navigate(['/']); // Redirection vers la page d'accueil
      return throwError(() => new Error('Session expirée. Veuillez vous reconnecter.'));
    }
    switch (err.status) {
      // case 400:
      //   this.toastService.error('Bad request. Please check your input');
      //   break;
      case 401:
        // this.toastService.error('Session expired. Please login again');
        // this.router.navigateByUrl('/login');
        break;
      // case 403:
      //   this.toastService.error('Access denied. You don\'t have permission to perform this action');
      //   break;
      case 404:
        // this.toastService.error('Resource not found');
        break;
      case 409:
        // this.toastService.error('Conflict detected. Please try again');
        break;
      case 422:
        // this.toastService.error('Invalid data provided');
        break;
      case 429:
        // this.toastService.error('Too many requests. Please try again later');
        break;
      case 500:
        // this.toastService.error('Server error. Please try again later');
        break;
      case 503:
        // this.toastService.error('Service unavailable. Please try again later');
        break;
      default:
        // this.toastService.error('An unexpected error occurred');
    }

    return throwError(() => err);
  }
}
